import React, { useEffect, useState } from "react";
import { Card, Button, Input, Modal, message, Tag, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { AgGridReact } from "ag-grid-react";

import api, { getUsers } from "@/services/api";
import { useTheme } from "@/contexts/ThemeContext";

const Users = () => {
  const { isDark } = useTheme();
  const [users, setUsers] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isLoading, setisLoading] = useState(true);
  const [filtered, setfiltered] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const { data, isError } = await getUsers();
      if (isError) {
      }

      setUsers(data?.data || []);
      setfiltered(data?.data || []);
      setisLoading(false);
    } catch (error) {
      setisLoading(false);
      message.error("Failed to fetch users");
    }
  };

  const handleToggleStatus = async (user) => {
    try {
      const newStatus = user.status === "active" ? "disabled" : "active";
      await api.patch(`/users/${user.id}`, { status: newStatus });
      message.success(
        `User ${newStatus === "active" ? "enabled" : "disabled"} successfully`,
      );
      fetchUsers();
    } catch (error) {
      message.error("Failed to update user status");
    }
  };

  const columnDefs = [
    {
      field: "uid",
      headerName: "ID",
      filter: true,
      resizable: true,
      width: 350,
      cellStyle: { fontSize: "13px" },
    },
    {
      field: "fullname",
      headerName: "Name",
      filter: true,
      cellStyle: { fontSize: "13px" },
    },
    {
      field: "email",
      headerName: "Email",
      filter: true,
      resizable: true,
      width: 250,
      cellStyle: { fontSize: "13px" },
    },
    {
      field: "role",
      headerName: "Role",
      filter: true,
      width: 80,
      cellStyle: { fontSize: "13px" },
    },
    {
      field: "isVerified",
      headerName: "Status",
      width: 80,
      cellStyle: { fontSize: "13px" },
      cellRenderer: (params) => (
        <Tag
          color={params.value ? "success" : "error"}
          style={{
            borderRadius: 0,
            fontWeight: 500,
            fontSize: 11,
            textTransform: "uppercase",
          }}
        >
          {params.value ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    // { field: "createdon", headerName: "Created", width: 130 },
    // { field: "updatedon", headerName: "Last Login", width: 130 },
    {
      headerName: "Actions",
      width: 80,
      cellStyle: { fontSize: "13px" },
      cellRenderer: (params) => (
        <Space>
          <Button
            size="small"
            danger={params.data.status === "active"}
            style={{ borderRadius: 0, fontWeight: 500 }}
            // onClick={() => handleToggleStatus(params.data)}
            data-testid={`toggle-user-${params.data.id}`}
          >
            {params.data.status === "active" ? "Disable" : "Enable"}
          </Button>
        </Space>
      ),
    },
  ];

  // const filteredUsers = users.filter((user) =>
  //   Object.values(user).some((val) =>
  //     String(val).toLowerCase().includes(searchText.toLowerCase()),
  //   ),
  // );
  function handleSearchByname(e) {
    const value = e.target.value?.toLowerCase();
    setSearchText(e.target.value);
    if (!value) {
      return setfiltered(users);
    }

    const filteredUsers = users.filter((v) => {
      const name = v?.fullname?.toLowerCase() || "";
      if (name?.includes(value)) {
        return v;
      }
    });

    setfiltered(filteredUsers);
  }

  return (
    <div>
      <div
        style={{
          marginBottom: 24,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <h1
            style={{
              fontSize: 28,
              fontWeight: 700,
              fontFamily: "IBM Plex Sans, sans-serif",
              letterSpacing: "-0.02em",
              marginBottom: 8,
            }}
          >
            Users Management
          </h1>
          <p
            style={{
              fontSize: 14,
              color: isDark ? "#A1A1AA" : "#71717A",
              margin: 0,
            }}
          >
            Manage all users and their permissions
          </p>
        </div>
      </div>

      <Card
        style={{
          borderRadius: 0,
          border: `1px solid ${isDark ? "#27272A" : "#E4E4E7"}`,
          background: isDark ? "#18181B" : "#FFFFFF",
        }}
      >
        <div style={{ marginBottom: 16 }}>
          <Input
            placeholder="Search users..."
            prefix={<SearchOutlined />}
            value={searchText}
            onChange={handleSearchByname}
            style={{ maxWidth: 400, borderRadius: 0 }}
            data-testid="users-search-input"
          />
        </div>
        <div
          className={isDark ? "ag-theme-alpine dark" : "ag-theme-alpine"}
          style={{ height: 400, width: "100%" }}
        >
          <AgGridReact
            rowData={filtered}
            columnDefs={columnDefs}
            pagination={true}
            loading={isLoading}
            paginationPageSize={10}
          />
        </div>
      </Card>

      <Modal
        title="User Details"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={[
          <Button
            key="close"
            onClick={() => setModalVisible(false)}
            style={{ borderRadius: 0 }}
          >
            Close
          </Button>,
        ]}
        styles={{ borderRadius: 0 }}
      >
        {selectedUser && (
          <div style={{ padding: "16px 0" }}>
            <p>
              <strong>Name:</strong> {selectedUser.name}
            </p>
            <p>
              <strong>Email:</strong> {selectedUser.email}
            </p>
            <p>
              <strong>Role:</strong> {selectedUser.role}
            </p>
            <p>
              <strong>Status:</strong> {selectedUser.status}
            </p>
            <p>
              <strong>Created:</strong> {selectedUser.createdAt}
            </p>
            <p>
              <strong>Last Login:</strong> {selectedUser.lastLogin}
            </p>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default Users;
